import {useClampLine} from '@/root/hooks/useClampLine';
import {HomeCardWithTitle} from '@/root/models/home';

type Props = {
  card: HomeCardWithTitle;
  onClickCard: (clickedCard: HomeCardWithTitle) => void;
};

const MyCardItem = ({card, onClickCard}: Props) => {
  const {title, subTitle, logoUrl, groupedCards} = card;
  const groupedCardLength = groupedCards.length;

  const [nodeRef, {clampText}] = useClampLine({
    text: card.title,
    appendText: groupedCardLength > 1 ? ` 외 ${groupedCardLength - 1}개` : ''
  });

  const isAllExpiredCard = (groupedCards: HomeCardWithTitle['groupedCards']) => {
    return groupedCards.every(({expired}) => expired);
  };

  return (
    <li className="item_card">
      <button type="button" className="btn_card" onClick={() => onClickCard(card)}>
        <strong ref={nodeRef} className="tit_card" role="text">
          {clampText}
        </strong>
        <span className="txt_card" role="text">
          {subTitle}
        </span>
        <span className="cont_info">
          {isAllExpiredCard(groupedCards) && <span className="txt_expired">만료</span>}
          <span className="thumb_icon">
            <img src={logoUrl} className="img_thumb" alt={title} />
          </span>
        </span>
      </button>
    </li>
  );
};

export default MyCardItem;
